/* DON'T EDIT THIS FILE: edit original and run build again */ export const fyoFullLabel = "FUTUROS Y OPCIONES.COM S.A";
